import propertyType from '../data/propertyType/propertyType.json';

type Locale = 'th-TH' | 'en-US';

export function getPropertyTypeLabel(
  code: string,
  locale: Locale = 'th-TH',
): string {
  const matched = propertyType.find((item) => item.code === code);

  if (!matched) return '';

  return matched[locale];
}
